@if (openPrintModal) {
  <div class="modal-backdrop fade show"></div>
}
<div class="modal fade" [ngClass]="{'show': openPrintModal}" id="exampleModal" style="display: block;" tabindex="-1"
  role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Map & Hotel</h5>
        <button type="button" class="close" (click)="closeModel()" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body route-planner-print-model">
        <div class="aa-print">
          Maps Print Preview!!;
          <aa-hybrid-google-map [mapType]="2" ></aa-hybrid-google-map>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModel()" data-bs-dismiss="modal">Close</button>

        <button type="button" class="btn print-btn" (click)="printMap()">
          <span>Print</span>
        </button>
      </div>
    </div>
  </div>
</div>